








import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import { ProductAttributeInfo } from '@eurogast/hub-client-typescript';
import ProductAttributeBadge from '@/search-result/badges/ProductAttributeBadge.vue';

@Component({
  components: {ProductAttributeBadge}
})
export default class ProductAttributeBadges extends Vue {
  @Prop({required: true})
  public attributes: ProductAttributeInfo[];
}
